

  import Vue from 'vue'
  import Component from "vue-class-component";
  import {namespace} from "vuex-class";
  import {IRealtimeData} from "@/model/Realtime/IRealtimeData";
  import {IAuthUserData} from "@/store/modules/authModule";
  import {PermissionHelper} from "@/helpers/PermissionHelper";
  import {EUserPermissions} from "@/model/EUserPermissions";

  const authModule = namespace("authModule");
  const realtimeModule = namespace("realtimeModule");

  @Component({})
  export default class Realtime extends Vue {

    @realtimeModule.Action('fetchRealtime')
    fetchRealtime!: () => void;
    @realtimeModule.Action('fetchFullDays')
    fetchFullDays!: () => void;
    @authModule.Getter('userData')
    private authUser!: IAuthUserData;

    @realtimeModule.Getter('realtime')
    realtime!: IRealtimeData;
    @realtimeModule.Getter('fullDays')
    fullDays!: IRealtimeData;

    e = 0;
    i!: any;
    s: number = (new Date()).getTime();

    get canShow(): boolean {
      const authUser = this.authUser;
      return authUser && (
        PermissionHelper.hasPermissionAny(authUser, EUserPermissions.PERMISSION_ADMINISTRATOR) ||
        PermissionHelper.hasPermissionAny(authUser, EUserPermissions.PERMISSION_DEVELOPER)
      );
    }
    get chevronUpDown(): string {
      const color = this.colorOfToday;
      return color == 'real-green' ? 'up' : 'down';
    }
    get colorOfToday(): string {
      const r = this.realtime;
      let biggerCnt = 0;
      if ((r.OrdersToday||0) >= r.OrdersLastWeekToday) {
        biggerCnt ++;
      }
      if ((r.OrdersToday||0) >= r.Orders4WeeksAgoToday) {
        biggerCnt ++;
      }
      if ((r.OrdersToday||0) >= r.OrdersLastYearToday) {
        biggerCnt ++;
      }
      switch (biggerCnt) {
        case 3:
        case 2:
          return 'real-green';
        case 1:
          return 'real-orange';
      }
      return 'real-red';
    }
    get ordersTarget(): number {
      const lastWeek = this.fullDays.OrdersLastWeekToday;
      const monthAgo = this.fullDays.Orders4WeeksAgoToday;
      const lastYear = this.fullDays.OrdersLastYearToday;
      return Math.max(lastWeek, monthAgo, lastYear) + 1;
    }

    created() {
      setTimeout(this.refreshAll, 1);
      this.i = setInterval(this.refreshAll, 60*1000);
    }

    beforeDestroy() {
      clearInterval(this.i);
    }

    colorOf(v: number, ref: number): string {
      return v >= ref ? 'real-green' : 'real-orange';
    }

    get easterEgg() {
      const a = this.e;
      const e = [
        '__̴ı̴̴̡̡̡ ̡͌l̡̡̡ ̡͌l̡*̡̡ ̴̡ı̴̴̡ ̡̡͡|̲̲̲͡͡͡ ̲▫̲͡ ̲̲̲͡͡π̲̲͡͡ ̲̲͡▫̲̲͡͡ ̲|̡̡̡ ̡ ̴̡ı̴̡̡ ̡͌l̡̡̡̡.___',
        '٩(- ̮̮̃-̃)۶',
        '\\,,/(^_^)\\,,/',
        '‛¯٭¯٭¯¯(▫▫)¯¯٭¯٭¯’',
        '☁ ▅▒░☼‿☼░▒▅ ☁',
        '✈__✈ █ █ ▄ ',
        '¯\\_(ツ)_/¯ ',
        '┏(-_-)┛┗(-_-)┓┗(-_-)┛┏(-_-)┓',
        '|̲̲̲͡͡͡ ̲▫̲͡ ̲̲̲͡͡π̲̲͡͡ ̲̲͡▫̲̲͡͡ ̲|̡̡̡ ̡ ̴̡ı̴̡̡ ̡͌l̡ ̴̡ı̴̴̡ ̡l̡*̡̡ ̴̡ı̴̴̡ ̡̡͡|̲̲̲͡͡͡ ̲▫̲͡ ̲̲̲͡͡π̲̲͡͡ ̲̲͡▫̲̲͡͡ |',
        '♪┏(°.°)┛┗(°.°)┓┗(°.°)┛┏(°.°)┓ ♪',
      ];
      if (Math.floor(((new Date()).getTime() - this.s) / 1000) < 4.2*3600) return e[1];
      return e[Math.floor(Math.random()*e.length)];
    }

    refreshAll() {
      this.e++;
      this.fetchRealtime();
      this.fetchFullDays();
      this.$uiBus.emit("closeDrawer");
    }

  }
